// @ts-nocheck
import React, { FC, useState } from 'react';
import { whichAuth as getAuth } from '../../getAuth';
import { REST_API_URL } from '../../constants/global';
import { IonSearchbar, IonProgressBar } from '@ionic/react';
import { UserSearchProps } from "./UserSearchProps.model";
import AlertModal from "../AlertModal";
import { handleErrors } from '../../utils/handleErrors';

export const search = async searchTerm => {
  if(searchTerm.length > 3) {
    const uri = REST_API_URL + (/^[0-9]+$/.test(searchTerm) ? '/users/' : '/users/search/findByFirebaseId?firebaseUid=') + searchTerm
    const token = await getAuth().currentUser.getIdToken();
    return fetch(uri, {headers: {'Authorization': 'Bearer ' + token}})
      .then(response => {
        if(response.status !== 200) {
          return Promise.resolve(null);
        }
        return response.json().then(user => Promise.all([
            // get payment info for user
            fetch(user._links.paymentInfo.href, {headers: {'Authorization': 'Bearer ' + token}})
              .then(handleErrors),
  
            // get providers for user
            fetch(user._links.invoiceRedirects.href, {headers: {'Authorization': 'Bearer ' + token}})
              .then(handleErrors)
              .then(invoiceRedirects => Promise.all(invoiceRedirects._embedded.invoiceRedirects.map(invoiceRedirect =>
                fetch(invoiceRedirect?._links?.provider.href, {headers: {'Authorization': 'Bearer ' + token}})
                  .then(handleErrors)
                  .then(provider => {
                    provider.status = invoiceRedirect.status;
                    return provider;
                  })
                )))
            ])
          .then(([paymentInfo, providers]) => ({
              ...user,
              paymentInfo,
              providers
            }
          )));
      })
  }
}
  
const UserSearch: FC<UserSearchProps> = ({ onSelect }) => {
  
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [modalMessage, setModalMessage] = useState<string>('');
  const [searchInProgress, setSearchInProgress] = useState<boolean>(false);
  
  const userSearch = searchTerm => {
    setSearchInProgress(true);
    search(searchTerm)
      .then(user => onSelect(user))
      .catch(response => {
        setIsOpenModal(true)
        setModalMessage('Failed to search user id ' + searchTerm)
      })
      .finally(() => setSearchInProgress(false));
  }
  
  return (
      <div style={{zIndex:'2', width:'100%', height: 'auto'}}>
        <IonSearchbar placeholder="User ID (e.g. 23409334)"
          onIonChange={searchTerm => userSearch(searchTerm.detail.value)}
          onIonClear={() => onSelect(null)} 
          debounce={400} />
        { searchInProgress && <IonProgressBar type="indeterminate" /> }
            
        <AlertModal
          isOpen={isOpenModal}
          title={modalMessage}
          onClosed={() => setIsOpenModal(false)}
        />
      </div>
  );
}

export default UserSearch;